import {
  faCaretDown,
  faCaretUp,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import AddTriviaQuestions from "./AddTriviaQuestions";
import CloseTrivia from "./CloseTrivia";
import DeleteTrivia from "./DeleteTrivia";
import IndividualTriviaQuestions from "./IndividualTriviaQuestions";
import ViewTriviaResponses from "./ViewTriviaResponses";

const TRIVIA_STATUS = {
  ACTIVE: 1,
  SCHEDULED: 2,
  INACTIVE: 0,
};
const styles = {
  listItem: {
    fontSize: 16,
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    fontWeight: "bold",
    alignItems: "center",
  },
  transitionCss: {
    transitionDelay: "3s",
  },
  activeBadge: {
    background: "green",
    marginLeft: "10px",
  },
  closedBadge: {
    background: "#dc3545",
    marginLeft: "10px",
  },
};

export default ({ data, setActiveTrivia, activeTrivia, setReload }) => {
  const classes = styles;
  const [create, setCreate] = useState(false);
  const [listRefresh, setListrefresh] = useState(false);
  const [closeTrivia, setCloseTrivia] = useState(false);
  const [viewTrivia, setViewTrivia] = useState(false);
  const params = useParams();

  return (
    <div key={data.id} class="list-group-item">
      <div style={classes.listItem}>
        <div>{data.name}</div>
        <div className="d-flex align-items-center">
          {data.status === TRIVIA_STATUS.SCHEDULED && (
            <div style={{ marginRight: "1rem" }}>Scheduled</div>
          )}
          {data.id === activeTrivia &&
            (data.status === TRIVIA_STATUS.ACTIVE ||
              data.status === TRIVIA_STATUS.SCHEDULED) && (
              <button
                className="btn btn-sm btn-light"
                onClick={() => setCreate(true)}
                disabled={data.status === TRIVIA_STATUS.INACTIVE}
              >
                Add Question <FontAwesomeIcon icon={faPlus} />
              </button>
            )}
          <DeleteTrivia
            triviaId={data.id}
            onClose={(flag) => {
              if (flag) {
                // refresh
                setListrefresh(!listRefresh);
                setReload();
              }
            }}
          />
          <FontAwesomeIcon
            icon={data.id === activeTrivia ? faCaretUp : faCaretDown}
            onClick={() =>
              setActiveTrivia(data.id === activeTrivia ? 0 : data.id)
            }
            style={{ cursor: "pointer", marginLeft: "10px" }}
          />
        </div>
      </div>
      {data.id === activeTrivia && (
        <div>
          <IndividualTriviaQuestions
            setCloseTrivia={setCloseTrivia}
            setViewTrivia={setViewTrivia}
            data={data}
            listRefresh={listRefresh}
          />
        </div>
      )}

      {create && (
        <AddTriviaQuestions
          onClose={(flag) => {
            if (flag) {
              // refresh
              setListrefresh(!listRefresh);
            }
            setCreate(false);
          }}
          triviaId={data.id}
        />
      )}

      {closeTrivia && (
        <CloseTrivia
          onClose={(flag = false) => {
            if (flag) {
              setListrefresh(!listRefresh);
            }
            setCloseTrivia(false);
            setReload();
          }}
          triviaId={data.id}
          teamId={params.teamId}
        />
      )}

      {viewTrivia && (
        <ViewTriviaResponses
          onClose={(flag = false) => {
            if (flag) {
              setListrefresh(!listRefresh);
            }
            setViewTrivia(false);
          }}
          triviaId={data.id}
        />
      )}
    </div>
  );
};
